import { useSelector } from "react-redux";
import useRoles from "../../../hooks/custom/useRoles";
import {
  AdminFormsRoute,
  AdminLandingPageRoute,
  AdminServicesRoute,
  AdminSettingsRoute,
  AdminUsersRoute,
  AssessmentRoute,
  BlueprintsRoute,
  ClientsRoute,
  CompletedPaymentsRoute,
  DashBoardRoute,
  DynamicBuilderRoute,
  MarketHubRoute,
  MessageRoute,
  CalendarRoute,
  UpcomingPaymentsRoute,
  InvoicesRoute,
} from "../../route/routes";

const useMenuData = () => {
  const { isManager } = useRoles();
  const { isAccountOwner } = useSelector((state) => state.user);

  const sidebarLinks = [
    { text: "Dashboard", icon: "/assets/images/dashboardIcon.svg", path: DashBoardRoute, display: () => true },
    { text: "Calendar", icon: "/assets/images/calendarIcon.svg", path: CalendarRoute, display: () => true },
    { text: "Clients", icon: "/assets/images/clientsIcon.svg", path: ClientsRoute, display: () => true },
    {
      text: "Payments",
      icon: "/assets/images/paymentsIcon.svg",
      nested: [
        { text: "Completed Payments", path: CompletedPaymentsRoute, display: () => true },
        { text: "Upcoming Payments", path: UpcomingPaymentsRoute, display: () => true },
        { text: "Invoices", path: InvoicesRoute, display: () => true },
      ],
    },
    { text: "Messages", icon: "/assets/images/messagesIcon.svg", path: MessageRoute, display: () => true },
    {
      text: "Program Manager",
      icon: "/assets/images/programManagerIcon.svg",
      nested: [
        { text: "Dynamic Builder", path: DynamicBuilderRoute, display: () => true },
        { text: "Blueprints", path: BlueprintsRoute, display: () => true },
      ],
    },
    { text: "Tasks", icon: "/assets/images/tasksIcon.svg", path: "/tasks", display: () => true },
    { text: "Assessments", icon: "/assets/images/assesmentsIcon.svg", path: AssessmentRoute, display: () => true },
    { text: "Market Hub", icon: "/assets/images/marketHubIcon.svg", path: MarketHubRoute, display: () => true },
  ];

  const sidebarAdminLinks = [
    {
      text: "Admin",
      icon: "/assets/images/adminSettingIcon.svg",
      enableDivider: true,
      nested: [
        { text: "Forms", path: AdminFormsRoute, display: () => isManager },
        { text: "Landing Page", path: AdminLandingPageRoute, display: () => isManager },
        { text: "Services", path: AdminServicesRoute, display: () => isManager },
        { text: "Users", path: AdminUsersRoute, display: () => isManager },
        { text: "Settings", path: AdminSettingsRoute, display: () => isAccountOwner },
      ],
    },
  ];

  const helpItem = {
    text: "Get Help",
    icon: "/assets/images/helpIcon.svg",
    path: "https://nativusapp.atlassian.net/wiki/spaces/NG/overview",
    externalLink: true,
    highlight: true,
    display: () => true,
  };

  // Function to process and clean menu items
  const processMenu = (menu) =>
    menu
      .map((item) => {
        if (item.nested) {
          const filteredNested = item.nested.filter((sub) => sub.display());
          if (filteredNested.length > 0) {
            return { ...item, nested: filteredNested };
          }
          return null;
        } else if (item.display()) {
          return item;
        }
        return null;
      })
      .filter(Boolean);

  return {
    menuItems: [...processMenu(sidebarLinks), ...processMenu(sidebarAdminLinks)],
    helpItem,
  };
};

export default useMenuData;
